import React from "react";

interface HeroSectionProps {
  title: string;              // 标题
  subtitle?: string;           // 副标题
  description?: string;        // 介绍文本
  buttonText?: string;         // 按钮文本
  buttonLink?: string;         // 按钮链接
  backgroundColor?: string;  // 可选的背景色
  textColor?: string;        // 可选的文字颜色
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  description,
  buttonText,
  buttonLink,
  backgroundColor = "bg-red-500",  // 默认背景色
  textColor = "text-white",        // 默认文字颜色
}) => {
  return (
    <header className={`${backgroundColor} ${textColor}`}>
      <div className="container mx-auto px-6 py-16">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">{title}</h1>
        <p className="text-xl md:text-2xl mb-8">{subtitle}</p>
        <p className="text-lg mb-8">{description}</p>
        {buttonText && buttonLink && <a href={buttonLink}>
            <button className="bg-white text-red-500 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition">
              {buttonText}
            </button>
          </a>
        }
      </div>
    </header>
  );
};

export default HeroSection;